import { IconsProps } from "./IconsProps";

export function IconSeparadorCaminho({ width, height, color} : IconsProps) {
  return (
    <svg width={ width ? width : "8" } height={ height ? height : "13" } viewBox="0 0 8 13" fill={ color ? color : "none" } xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.646447 0.146447C0.841709 -0.0488155 1.15829 -0.0488155 1.35355 0.146447L7.35355 6.14645C7.54882 6.34171 7.54882 6.65829 7.35355 6.85355L1.35355 12.8536C1.15829 13.0488 0.841709 13.0488 0.646447 12.8536C0.451184 12.6583 0.451184 12.3417 0.646447 12.1464L6.29289 6.5L0.646447 0.853553C0.451184 0.658291 0.451184 0.341709 0.646447 0.146447Z" fill={ color ? color : "#6C757D" } />
    </svg>
  )
}